import {Grid} from "@mui/material";
import {HUB_EXTRAS_ACCESS_OPEN} from "../../settings-select/app-settings-form/constants";
import UserSelect from "../../user-select";

const UserSelectButton = ({hub, nodes, user, disabled, viewMode, onNavigate}) =>
  hub?.extras.Access === HUB_EXTRAS_ACCESS_OPEN || user.isAuthenticated ? (
    <Grid className="user-settings-btn">
      <UserSelect nodes={nodes} disabled={disabled} viewMode={viewMode} onNavigate={onNavigate} />
    </Grid>
  ) : null;

export default UserSelectButton;
